import { render, staticRenderFns } from "./picker-column.vue?vue&type=template&id=32709f20&scoped=true&"
import script from "./picker-column.vue?vue&type=script&lang=js&"
export * from "./picker-column.vue?vue&type=script&lang=js&"
import style0 from "./picker-column.vue?vue&type=style&index=0&id=32709f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32709f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32709f20')) {
      api.createRecord('32709f20', component.options)
    } else {
      api.reload('32709f20', component.options)
    }
    module.hot.accept("./picker-column.vue?vue&type=template&id=32709f20&scoped=true&", function () {
      api.rerender('32709f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/m-picker/picker-column.vue"
export default component.exports